<template>
  <fragment>
    <template v-if="fetchedError">sprawdź cenę w sklepie</template>
    <template v-else>
      <template v-if="fetchedPrice[productCode]">
        {{ prefix }}{{ fetchedPrice[productCode] | priceFormat }}&nbsp;zł
      </template>
      <template v-else-if="productCode === 'none'">bezpłatnie</template>
      <template v-else>sprawdź cenę w sklepie</template>
    </template>
  </fragment>
</template>
<script>
import price from "../../shared/price";
import { Fragment } from "vue-fragment";

export default {
  components: { Fragment },
  mixins: [price],
  props: {
    fetchedPrice: {
      type: Object,
      default() {
        return {
          standard_price: 0,
          promotion_price: 0,
        };
      },
    },
    fetchedError: {
      type: Boolean,
    },
    prefix: {
      type: String,
      default: "",
    },
    productCode: {
      type: String,
      default: "mobilne-dodatki",
      validator(value) {
        return ["none", "mobilne-dodatki", "mobilne-dodatki-plus"].includes(
          value
        );
      },
    },
  },
};
</script>
